export default "__VITE_ASSET__AfObbENO__"